// Kha'Zix — Unseen Threat: strikes the nearest enemy. If they are the last enemy alive,
// deals 3× damage — an execute for isolated prey.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const khazixLeap: Ability = {
  id: "khazixLeap",
  displayName: "Unseen Threat",
  description: "Strikes the nearest enemy for physical damage. Deals 3× damage if they are the last enemy alive.",
  iconId: "KhazixE",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const front = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    return front ? [front.pos] : [caster.pos];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q);
    const target = enemies[0];
    if (!target) return [];

    const stats = effectiveStats(caster);
    const isolated = enemies.length === 1;
    const dmg = physicalDamage(stats.ad * (isolated ? 3.0 : 1.5) + 60);
    return [{ target, amount: dmg, type: "physical" }];
  },
};
